var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfPickupGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1285 1.27453C49.8705 4.46104 54.8958 11.843 57.6597 19.7134C60.4875 27.7654 61.2067 36.7599 57.2471 44.3248C53.3196 51.8284 45.4251 56.0113 37.3214 58.5703C29.2976 61.1041 20.2709 62.5602 13.0301 58.2878C6.06902 54.1806 4.11973 45.5578 2.06588 37.7683C0.176962 30.6044 -1.40177 22.9906 1.98409 16.395C5.36389 9.81114 12.4666 6.58944 19.415 3.97231C26.8283 1.18007 34.8037 -1.74025 42.1285 1.27453Z",
    fill: "#C5E2CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 50.3184V22.1518L32 13.4851L51.5 22.1518V50.3184",
    stroke: "#009653",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.166 32.9851H42.8327V50.3184H21.166V37.3184H34.166",
    stroke: "#009653",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 50.3183V30.8183C34.1667 29.6217 33.1966 28.6516 32 28.6516H27.6667C26.47 28.6516 25.5 29.6217 25.5 30.8183V37.3183",
    stroke: "#009653",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfPickupGreen);
export default __webpack_public_path__ + "static/media/SelfPickupGreen.84633045bd15a76e55df702ec2c43073.svg";
export { ForwardRef as ReactComponent };